export default "__VITE_ASSET__BTYQGFHd__"